import { Button, Card, Spinner } from 'flowbite-react'
import React, { useContext, useEffect, useState } from 'react'
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput'
import CustomInput from '../../../components/CustomInputs/CustomInput'
import client from '../../../api/client'
import showToast from '../../../components/CustomToast/toastHelper'
import CustomModal from '../../../components/Modal/CustomModal'
import PaymentSummaryModal from '../PaymentSummaryModal/PaymentSummaryModal'
import ValidatePaymentModal from '../ValidatePaymentModal/ValidatePaymentModal'
import { UserContext } from '../../../contexts/UserContext'
import NotificationPopupModal from '../../../components/NotificationPopupModal/NotificationPopupModal'

export interface AirtimePurchaseProps {
  hasPin: boolean,
  triggerPinSetup: Function
}
const AirtimePurchase = ({ hasPin, triggerPinSetup }: AirtimePurchaseProps) => {
  const [providers, setProviders] = useState<any>([])
  const [billerItems, setBillerItems] = useState<any>([])
  const [selectedBiller, setSelectedBiller] = useState<any>()
  const [activePackage, setActivePackage] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const [amount, setAmount] = useState<number>(0)
  const [allGood, setAllGood] = useState<boolean>(false)
  const [categoryId, setCategoryId] = useState<number>(0)
  const [openDetailsModal, setOpenDetailsModal] = useState<boolean>(false)
  const [transactionId, setTransactionId] = useState<any>(1)
  const [openValidationModal, setOpenValidationModal] = useState<boolean>(false)
  const [payload, setPayload] = useState<any>(null)
  const [openPinCreationModal, setOpenPinCreationModal] = useState<boolean>(false)

  // const { userDetails } = useContext(UserContext) ?? {}

  // useEffect(() => {
  //   if (userDetails?.user?.pin !== null) {
  //     setHasPin(true)
  //   }
  // })

  // const handleCTAButtonClick = () => {
  //   if (!hasPin) {
  //     setOpenPinCreationModal(true)
  //   }
  //   else {
  //     setOpenValidationModal(true)
  //   }
  // }

  // const handleCallToAction = () =>{
  //   if(type == 'intro'){
  //     setType('pinCreationMessage')
  //   }
  //   else if(type == "pinCreationMessage"){
  //     handleSendOtp()
  //     setOpenPinModal(false)
  //     setOpenOtpModal(true)
  //   }
  // }

  const handleClick = () => {
    const canProceed = triggerPinSetup();
    console.log(canProceed);

    if (canProceed) {
      setOpenValidationModal(true)
    } else {
      console.log("PIN setup required!");
    }
  };

  const validateInputs = () => {
    if (selectedBiller == null || phoneNumber == '' || amount == 0) {
      setAllGood(false)
    }
    else {
      setAllGood(true)
    }
  }

  const getProviders = async () => {
    try {
      const response = await client.get('/subsidiary/dashboard/bills-payment/airtime/providers/get');
      console.log(response);

      setProviders(response.data.data);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('error getting data', err);
        showToast(message, "error");
      }
    }
  };

  const getBillerItems = async (billerId: number) => {
    try {
      const response = await client.get(`/subsidiary/dashboard/bills-payment/biller/${billerId}/packages`);
      console.log(response);
      return response.data.data
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        const message = err?.response?.data?.message;
        console.error('error getting data', err);
        showToast(message, "error");
      }
    }
  };

  const handleSelection = async (billerId: number) => {
    console.log(billerId);

    const selectedBiller = providers.find((x: any) => x.id == billerId)
    console.log(selectedBiller);

    setSelectedBiller(selectedBiller?.slug)
    setCategoryId(selectedBiller?.billerCategoryId)
    const packages = await getBillerItems(billerId)
    const activePackage = packages[0]
    setActivePackage(activePackage?.slug ?? "")
  }

  useEffect(() => {
    const fetchData = async () => {
      await getProviders()
    }
    fetchData()
  }, [])

  useEffect(() => {
    validateInputs()
    constructPayload()
  }, [selectedBiller, amount, phoneNumber])

  const constructPayload = () => {
    const payload = {
      customerId: phoneNumber,
      billerSlug: selectedBiller,
      amount: amount,
      productName: activePackage,
      billCategoryId: categoryId
    }
    setPayload(payload)
  }


  return (
    <div className='grid grid-cols-1 md:grid-cols-3'>
      <div>
        <p className='text-xl font-semibold'>Airtime Purchase</p>
        <p className='text-xs'>Enter your details to purchase your airtime</p>
      </div>
      <div className='md:col-span-2 mr-8'>
        <Card className='shadow-none'>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <CustomSelectInput label='Service Provider' items={providers} displayKey='name' valueKey='id' onChange={(item: any) => handleSelection(item)} />
            <CustomInput label='Phone number' name='phoneNumber' value={phoneNumber} onChange={(e: any) => setPhoneNumber(e.target.value)} />
          </div>
          <div>
            <CustomInput label='Amount' onFocus={() => amount === 0 && setAmount(NaN)} type='number' name='amount' value={amount} onChange={(e: any) => setAmount(e.target.value)} />
          </div>
          <div className='flex justify-end '>
            <Button className='w-full md:w-2/6 rounded-sm bg-custom-button-green text-black hover:text-white' disabled={allGood == false} onClick={() => handleClick()}>{loading ? <Spinner size='sm' /> : 'Buy Airtime'}</Button>
          </div>
        </Card>
      </div>
      <CustomModal show={openValidationModal} icon='' dismissible onClose={() => setOpenValidationModal(false)} size='md'>
        <ValidatePaymentModal payload={payload} closeVerificationModal={() => setOpenValidationModal(false)} />
      </CustomModal>


    </div>
  )
}

export default AirtimePurchase
